import Immutable from 'seamless-immutable';
import _ from 'lodash';
import AppCardModel from './app-card-model';

/**
 * Transforms and array of backend app card models into frontend app card models. These are to be used as a shared controlled entry point for AppStore and AppCreate
 * @typedef {Object} Response
 * @param {Object[]} content - backend formatted app cards
 * @returns {Object[]} AppCardModels - front end app card models
 */
function deserialize(content = []) {
  return Immutable(_.map(content, AppCardModel.deserialize));
}

export default {
  deserialize,
};
